exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.conference-room {\n  width: 40%;\n  height: 40%;\n}\n", ""]);

// exports
